import React, { Fragment, useEffect, useRef, useState } from "react";
import Fliter from "../../common/filter/Fliter";
import StarRating from "../../common/filter/StarRating";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  getLoading,
  getSearchedTransfers,
  transferSearchAsync,
  transferSearchReturnAsync,
} from "../../../features/bookings/transferSlice";
import TransferList from "./TransferList";

import Loader from "../../../helpers/Loader";
import MainModal from "../../modals/MainModal";
import SelectedVehicle from "./SelectedVehicle";
import { scrollFunc } from "../../../helpers/helper";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { TransferFilter } from "../../common/filter/TransferFilter";
import { getLogin } from "../../../features/userSlice";

const Transfer = () => {
  const smoothRef = useRef();
  const [modal, setModal] = useState("login");
  const [show, setShow] = useState(false);
  const transferSearched = useSelector(getSearchedTransfers);
  const loading = useSelector(getLoading);
  const dispatch = useDispatch();

  const [transferData, setTransferData] = useState([]);
  const [transferDataBackup, setTransferDataBackup] = useState([]);
  const [tcount, setTcount] = useState(1); //for temp
  const [pickupVehicle, setPickupVehicle] = useState("");
  const [viewRoundTrip, setviewRoundTrip] = useState(false);
  const [retrunTransfer, setReturnTransfer] = useState(false);
  const [minPrice, setMinPirce] = useState(0);
  const [maxPrice, setMaxPrice] = useState(0);
  const [respFilter, setRespFilter] = useState(false);
  const signatureData = useSelector(
    (state) => state.transfer.signature,
    shallowEqual
  );
  const userDatas = useSelector(getLogin);
  const userData = JSON.parse(sessionStorage.getItem("userData")) || {};
  const { Authorization } =
    JSON.parse(sessionStorage.getItem("userData")) || {};
  // JSON.parse(sessionStorage.getItem("signatureData"));
  const [returnData, setReturnData] = useState([]);
  const [resetFilter, setResetFilter] = useState(false);
  const [searchParams] = useSearchParams();
  const [loader, setLoader] = useState(true);
  const [queryData, setQueryData] = useState(
    Object.fromEntries([...searchParams])
  );
  const [previousLogin, setPreviousLogin] = useState(
    Object.keys(userData).length
  );

  // const login = useSelector(getLogin);
  const navigate = useNavigate();

  const [agent, setAgent] = useState(0);

  const [isBook, setIsBook] = React.useState(false);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => {
        setLoader(false);
      }, 800);
    }
  }, [loading]);

  useEffect(() => {
    if (Object.keys(userData).length > 0) {
      if (previousLogin === 0 && userData?.role === "Agent") {
        setPreviousLogin(1);
      }
    }
  }, [userDatas]);

  // useEffect(() => {
  //   let depature = JSON.parse(sessionStorage.getItem("departure"));

  //   if (depature !== null) {
  //     let returnData = JSON.parse(sessionStorage.getItem("return"));

  //     if (returnData === null) {
  //       dispatch(transferSearchAsync({ depature, signatureData }));
  //     } else {
  //       const { returnJourney } = returnData;
  //
  //       dispatch(
  //         transferSearchReturnAsync({ depature, returnJourney, signatureData })
  //       );
  //     }
  //   }
  // }, []);

  const GetTrannsferData = () => {
    var queryData = Object.fromEntries([...searchParams]);
    setPickupVehicle("");
    if (Object.keys(queryData).length > 0) {
      const depature = JSON.parse(queryData.departure);

      setTcount(depature.tcount);

      let tripType = queryData.tripType;

      if (tripType === "roundtrip" && signatureData !== "") {
        const returnJourney = JSON.parse(queryData.returnJourney);
        setReturnTransfer(true);
        signatureData !== null &&
          dispatch(
            transferSearchReturnAsync({
              depature,
              returnJourney,
              signatureData,
              Authorization,
            })
          );
      } else if (signatureData !== "" && tripType === "oneway") {
        setReturnTransfer(false);
        signatureData !== null &&
          dispatch(
            transferSearchAsync({ depature, signatureData, Authorization })
          );
      }
    } else {
      let depature = JSON.parse(sessionStorage.getItem("departure"));
      {
        depature !== null && setTcount(depature.tcount);
      }
    }
    setMaxPrice(0);
  };

  useEffect(() => {
    // setQueryData(Object.fromEntries([...searchParams]));
    var data = Object.fromEntries([...searchParams]);

    if (Object.keys(data).length > 0) {
      GetTrannsferData(data);
      setMaxPrice(0);
    }
  }, [searchParams, previousLogin, signatureData, agent]);

  // useEffect(() => {
  //   GetTrannsferData();
  //   // if (queryData?.tripType === "oneway") {
  //   //   setPickupVehicle("");
  //   // }
  // }, [queryData, signatureData]);
  useEffect(() => {
    var queryData = Object.fromEntries([...searchParams]);
    const passFilterData = transferSearched?.TransferResults?.filter(
      (veh) => veh.Vehicles[0].PaxCapacity >= tcount
    );
    if (queryData.tripType === "roundtrip") {
      setReturnTransfer(true);
      setviewRoundTrip(false);
      const passReturnFilterData =
        transferSearched?.TransferReturnResults?.filter(
          (veh) => veh.Vehicles[0].PaxCapacity >= tcount
        );
      setReturnData(passReturnFilterData);
    } else {
      // setReturnTransfer(false);
    }
    // else {
    //   setviewRoundTrip(!val);
    // }
    setTransferData(passFilterData !== undefined ? passFilterData : []);

    setTransferDataBackup(passFilterData);
    smoothRef.current?.scrollIntoView({ behavior: "smooth" });
    if (passFilterData !== undefined) {
      var MinPrices = Math.min(
        ...passFilterData.map(
          (price) => price["Vehicles"][0]["Price"]["TotalPrice"]
        )
      );
      var MaxPrices = Math.max(
        ...passFilterData.map(
          (price) => price["Vehicles"][0]["Price"]["TotalPrice"]
        )
      );

      setMinPirce(MinPrices);
      setMaxPrice(MaxPrices);
    }
    // sessionStorage.setItem("departure", JSON.stringify(depature));
  }, [transferSearched, searchParams]);

  // useEffect(() => {
  //   if (
  //     Object.keys(userDatas).length > 0 &&
  //     isBook === true

  //   ) {
  //     navigate({
  //       pathname: "/transfer-details",
  //     });
  //   }
  // }, [userDatas, isBook]);

  const filter = (data) => {
    const PriceSort = data["PriceSort"];
    const TransferType = data["TransferType"];
    const PriceRange = data["PriceRange"];
    const Reset = data["Reset"];
    var tempTransferData;

    //TRANSFER TYPE

    tempTransferData = transferDataBackup.filter((t) =>
      TransferType.length > 0
        ? TransferType.includes(t["Vehicles"][0]["Type"])
        : true
    );

    //PRICE SORTING
    if (PriceSort.length > 0) {
      if (PriceSort[0] === "MinToMax") {
        tempTransferData = tempTransferData.sort(
          (a, b) =>
            parseFloat(a["Vehicles"][0]["Price"]["TotalPrice"]) -
            parseFloat(b["Vehicles"][0]["Price"]["TotalPrice"])
        );
      } else {
        tempTransferData = tempTransferData.sort(
          (a, b) =>
            parseFloat(b["Vehicles"][0]["Price"]["TotalPrice"]) -
            parseFloat(a["Vehicles"][0]["Price"]["TotalPrice"])
        );
      }
    }

    //PRICE RANGE
    if (PriceRange.length > 0) {
      tempTransferData = tempTransferData.filter(
        (p) =>
          p["Vehicles"][0]["Price"]["TotalPrice"] >= PriceRange[0] &&
          p["Vehicles"][0]["Price"]["TotalPrice"] <= PriceRange[1]
      );
    }

    //RESET FILTER
    if (Reset) {
      tempTransferData = transferDataBackup;
      setMaxPrice("");
      setMinPirce("");
      setTimeout(() => {
        setMaxPrice(maxPrice);
        setMinPirce(minPrice);
      }, 300);

      setResetFilter(true);
      //RESET
      // HotelListingHandler();
    }
    // if (Reset === true) {
    //   CLearFilter(true);
    // }
    setTransferData(tempTransferData);
  };

  useEffect(() => {
    if (queryData.tripType === "roundtrip") {
      setTransferData(returnData);
    }
  }, [viewRoundTrip]);

  const removePickupHandler = () => {
    setPickupVehicle("");
    sessionStorage.setItem("transferSelected", "");
    setviewRoundTrip(false);
  };

  // if (loading) {
  //   return <Loader />;
  // }

  return (
    <>
      <section className="hotel-listing-main" ref={smoothRef}>
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <TransferFilter
                maxp={maxPrice}
                minp={minPrice}
                Reset={resetFilter}
                filterData={(data) => {
                  filter(data);
                }}
              />
            </div>
            <div className="col-lg-9 mt-4">
              <div className="title2">
                <h5>Onwards Journey</h5>
                {loader ? (
                  <div className="hotel-listing-wrap gray-border">
                    <div className="row justify-content-between align-items-center w-100">
                      <div className="col-lg-3">
                        <div className="loader-bg structure-box2"></div>
                      </div>
                      <div className="col-lg-6">
                        <span className="loader-bg p-3 mb-2 d-block w-25 rounded"></span>
                        <span className="loader-bg pt-4 mb-2 d-block w-50 me-2 rounded"></span>
                        <span className="loader-bg pt-4 mb-2 d-block w-25 me-2 rounded"></span>
                        <span className="loader-bg pt-4 mb-2 d-block w-50 me-2 rounded"></span>
                        <span className="loader-bg pt-4 mb-2 d-block w-50 me-2 rounded"></span>
                      </div>
                      <div className="col-lg-3">
                        <span className="loader-bg p-3 mb-2 d-block w-25 rounded"></span>
                        <span className="loader-bg p-3 mb-2 d-block w-50 rounded"></span>
                        <span className="loader-bg pt-4 mb-2 d-block w-75 me-2 rounded"></span>
                        <span className="loader-bg pt-4 mb-2 d-block w-50 me-2 rounded"></span>
                      </div>
                    </div>
                  </div>
                ) : (
                  !viewRoundTrip && (
                    <>
                      {transferData !== undefined
                        ? transferData.map((val, ind) => {
                            return (
                              <TransferList
                                val={val}
                                key={ind}
                                setShow={setShow}
                                show={show}
                                returnTransfer={retrunTransfer}
                                setReturnTransfer={setReturnTransfer}
                                setModal={setModal}
                                methods={{
                                  setPickupVehicle,
                                  setviewRoundTrip,
                                }}
                                previousLogin={previousLogin}
                                isBook={isBook}
                                setIsBook={setIsBook}
                                login={userDatas}
                              />
                            );
                          })
                        : "asdasdd"}
                    </>
                  )
                )}

                {viewRoundTrip && (
                  <>
                    {pickupVehicle !== undefined && pickupVehicle !== "" && (
                      <Fragment>
                        <SelectedVehicle
                          unselect={removePickupHandler}
                          pickupVehicle={pickupVehicle}
                        />
                        <div className="title2">
                          <h5>Return Journey</h5>
                        </div>
                      </Fragment>
                    )}

                    {transferData?.map((val, ind) => {
                      return (
                        <TransferList
                          val={val}
                          key={ind}
                          setShow={setShow}
                          show={show}
                          setModal={setModal}
                          methods={{ setPickupVehicle, setviewRoundTrip }}
                          isBook={isBook}
                          setIsBook={setIsBook}
                          login={userDatas}
                        />
                      );
                    })}
                  </>
                )}
                {parseInt(transferData?.length) === 0 && !loading && (
                  <div className="transfer-wrap">
                    <div className="row align-items-center">
                      <div className="col-lg-3">
                        <div className="car-rental-image-wrap">
                          <img
                            src="/assets/images/car-rental/no-car.svg"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="col-lg-9">
                        <div className="transfer-inner no-cars-wrap">
                          <h4 className="bold20">
                            Looks empty, you've no Transfer Available
                          </h4>
                          <p>Please modify your search for more Transfer</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {show ? (
                  <MainModal
                    modal={modal}
                    setShow={setShow}
                    show={show}
                    setModal={setModal}
                    // extraData={val.DayRates[0]}
                  />
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Transfer;
